
export const calculateFoulsStats = (matches: any[]) => {
  let totalFouls = 0;
  matches.forEach(match => {
    totalFouls += (parseInt(match.HF) || 0) + (parseInt(match.AF) || 0);
  });

  const totalGames = matches.length;
  // Create thresholds from 11.5 to 25.5
  const thresholds = Array.from({ length: 15 }, (_, i) => 11.5 + i);
  const overUnderStats = thresholds.map(threshold => {
    let overCount = 0;
    matches.forEach(match => {
      const totalMatchFouls = (parseInt(match.HF) || 0) + (parseInt(match.AF) || 0);
      if (totalMatchFouls > threshold) {
        overCount++;
      }
    });
    return {
      threshold,
      over: ((overCount / totalGames) * 100).toFixed(1),
      under: (((totalGames - overCount) / totalGames) * 100).toFixed(1)
    };
  });

  return {
    total: totalFouls,
    average: (totalFouls / matches.length).toFixed(2),
    overUnderStats
  };
};

export const calculateTeamFouls = (matches: any[], isHome?: boolean) => {
  let totalFouls = 0;
  const teamStats = new Map<string, { total: number; games: number }>();
  // Create thresholds from 6.5 to 20.5
  const thresholds = Array.from({ length: 15 }, (_, i) => 6.5 + i);
  const overUnderCounts = thresholds.map(threshold => ({
    threshold,
    overCount: 0,
    underCount: 0
  }));

  matches.forEach(match => {
    let matchFouls = 0;
    
    if (isHome === true) {
      matchFouls = parseInt(match.HF) || 0;
      totalFouls += matchFouls;
      const team = match.HomeTeam;
      if (!teamStats.has(team)) {
        teamStats.set(team, { total: 0, games: 0 });
      }
      const stats = teamStats.get(team)!;
      stats.total += matchFouls;
      stats.games += 1;
    } else if (isHome === false) {
      matchFouls = parseInt(match.AF) || 0;
      totalFouls += matchFouls;
      const team = match.AwayTeam;
      if (!teamStats.has(team)) {
        teamStats.set(team, { total: 0, games: 0 });
      }
      const stats = teamStats.get(team)!;
      stats.total += matchFouls;
      stats.games += 1;
    } else {
      const homeFouls = parseInt(match.HF) || 0;
      const awayFouls = parseInt(match.AF) || 0;
      matchFouls = homeFouls + awayFouls;
      totalFouls += matchFouls;
      
      const homeTeam = match.HomeTeam;
      if (!teamStats.has(homeTeam)) {
        teamStats.set(homeTeam, { total: 0, games: 0 });
      }
      const homeStats = teamStats.get(homeTeam)!;
      homeStats.total += homeFouls;
      homeStats.games += 1;

      const awayTeam = match.AwayTeam;
      if (!teamStats.has(awayTeam)) {
        teamStats.set(awayTeam, { total: 0, games: 0 });
      }
      const awayStats = teamStats.get(awayTeam)!;
      awayStats.total += awayFouls;
      awayStats.games += 1;
    }

    overUnderCounts.forEach(count => {
      if (matchFouls > count.threshold) {
        count.overCount++;
      } else {
        count.underCount++;
      }
    });
  });

  let mostFouls = { team: '', value: 0 };
  let leastFouls = { team: '', value: Infinity };

  teamStats.forEach((stats, team) => {
    const average = stats.total / stats.games;
    if (average > mostFouls.value) {
      mostFouls = { team, value: average };
    }
    if (average < leastFouls.value) {
      leastFouls = { team, value: average };
    }
  });

  const totalGames = matches.length;
  const average = (totalFouls / totalGames).toFixed(2);

  const overUnderStats = overUnderCounts.map(({ threshold, overCount }) => ({
    threshold,
    over: ((overCount / totalGames) * 100).toFixed(1),
    under: (((totalGames - overCount) / totalGames) * 100).toFixed(1)
  }));

  return {
    totalFouls,
    averageFoulsPerGame: average,
    mostFouls: { team: mostFouls.team, average: mostFouls.value.toFixed(2) },
    leastFouls: { team: leastFouls.team, average: leastFouls.value.toFixed(2) },
    overUnderStats
  };
};

export const calculateDetailedFoulsStats = (matches: any[]) => {
  const overallStats = calculateTeamFouls(matches);
  const homeStats = calculateTeamFouls(matches, true);
  const awayStats = calculateTeamFouls(matches, false);

  return {
    overall: overallStats,
    home: homeStats,
    away: awayStats,
  };
};
